import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LookupSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LookupSVG;
